import { useNavigate } from 'react-router-dom';
import { useRouteError } from 'react-router-dom';
import MainNavigation from '../components/MainNavigation';
import ErrorIcon from './../assets/500_error_icon.svg?react';
import Button from '../components/ui/Button';

import './Error.scss';

function ErrorPage() {
	const navigate = useNavigate();

	const error = useRouteError();

	const returnHandler = () => {
		navigate('/dashboard');
	};

	return (
		<>
			<MainNavigation />
			<main id='error-content'>
				<div className='error-icon-container'>
					<ErrorIcon />
				</div>
				<h1>Something went wrong!</h1>
				<h5>{error.statusText}</h5>
				<p className='error-text'>
					We apologize, but the service you are trying to
					access is currently unavailable. Please try again
					later, or contact our support team for assistance.
				</p>
				<Button
					className='primary-button'
					onClick={returnHandler}
				>
					Return to Dashboard
				</Button>
			</main>
		</>
	);
}

export default ErrorPage;
